import React, { useState } from "react";
import "./Service1.css";

import emp1 from "../Imges/offsetPrinting.png";
import emp2 from "../Imges/WebPrinting.jpeg";
import emp3 from "../Imges/creativeDesign.jpg";
import emp4 from "../Imges/Service555.jpg";
import emp5 from "../Imges/supple.jpg";
import emp6 from "../Imges/6.jpg";
import emp7 from "../Imges/Service444.avif";
import emp8 from "../Imges/Newspaper Advertising.jpg";
import emp9 from "../Imges/Handbill Printing.jpg";
import emp10 from "../Imges/demovan.png";
import emp11 from "../Imges/Social Media Marketing.png";
import emp12 from "../Imges/Multiplex Branding.png";
import emp13 from "../Imges/SMS.jpg";

const services = [
  { title: "OFFSET PRINTING", description: "All types of Leaflet, Brochures, Catalogue, Stationary Printing", image: emp1 },
  { title: "WEB PRINTING", description: "All types of Leaflet, Brochures, Catalogue, Stationary Printing", image: emp2 },
  { title: "CREATIVE DESIGN", description: "Innovative & Eye Catching Designing for Print as well as visual media", image: emp3 },
  { title: "SIGNAGE", description: "Flex Banners | Vinyl | Inkjet Print | Direction Board | LED Sign Board", image: emp4 },
  { title: "AREA WISE ADVERTISING SUPPLEMENTS", description: "Innovative & Eye Catching Designing for Print", image: emp5 },
  { title: "FM RADIO (ALL OVER GUJARAT)", description: "Radio City | Radio Mirchi | MyFM | BigFM", image: emp6 },
  { title: "HOARDING", description: "All Over South Gujarat", image: emp7 },
  { title: "NEWSPAPER ADVERTISING", description: "All Newspapers (Gujarati, Hindi & English)", image: emp8 },
  { title: "HANDBILL PRINTING & DISTRIBUTION", description: "Distribution throughout Gujarat", image: emp9 },
  { title: "DEMOVAN", description: "Road Show For Product Promotion", image: emp10 },
  { title: "SOCIAL MEDIA", description: "Distribution throughout Gujarat", image: emp11 },
  { title: "MULTIPLEX BRANDING", description: "Road Show For Product Promotion", image: emp12 },
  { title: "SMS BRANDING", description: "Distribution through out Gujarat", image: emp13 },
];

const ServicesGrid = () => {
  const [modalContent, setModalContent] = useState(null);  // State to manage modal content
  const [modalVisible, setModalVisible] = useState(false);  // State to manage modal visibility

  const openModal = (service) => {
    setModalContent(service);  // Set the clicked service as modal content
    setModalVisible(true);  // Show the modal
  };

  const closeModal = () => {
    setModalVisible(false);  // Hide the modal
  };

  return (
    <div className="services-page">
      {/* Section Title */}
      <h2 className="section-title" style={{marginTop:'0%'}}>
        <span className="title-bar">|</span>OUR SERVICES<span className="title-bar">|</span>
      </h2>

      <div className="masonry-grid">
        {services.map((service, index) => (
          <div key={index} className="masonry-card" onClick={() => openModal(service)}>
            <img src={service.image} alt={service.title} className="masonry-image" />
            <div className="masonry-overlay">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>

     
    </div>
  );
};

export default ServicesGrid;
